export const ASMT_ADM = 'asmt-adm'
export const ASMT_MDT = 'asmt-mdt'
export const ASMT_NURSE = 'rapid-asmt'
export const ASMT_NURSE_SPECIALITY = 'rapid-asmt-sp'
export const ASMT_NURSE_SYNDROME = 'rapid-asmt-syn'
export const ASMT_SPECIALITY = 'asmt-sp'
export const ASMT_SYNDROME = 'asmt-syn'
export const ASMT_WARD = 'asmt-ward'
